export function isNil<T>(value: T | null | undefined): value is null | undefined {
  return isNull(value) || isUndefined(value)
}

export function isNull<T>(value: T | null): value is null {
  return value === null
}

export function isUndefined<T>(value: T | undefined): value is undefined {
  return value === undefined
}

export function isFilled<T extends string | number | boolean | null | undefined>(
  value: T,
): value is T extends string ? NonNullable<T> & string : NonNullable<T> {
  if (typeof value === "string") return value.length > 0
  if (typeof value === "number" && isNaN(value)) return false

  return !isNil(value)
}
